export default __webpack_public_path__ + "static/media/room-with-blurred-person.871a0743.jpg";